import cx from 'classnames';
import styles from '../Product.module.scss';

export interface ProductComparisonCardProps {
  children: React.ReactNode;
  className?: string;
  isLucid?:boolean
}

export const ProductComparisonCard = ({
  children,
  className,
  isLucid
}: ProductComparisonCardProps) => {
  return (
    <div className={cx(styles['product-comparison__card'], isLucid? styles['tablet-desktop']:'', className)}>
      {children}
    </div>
  );
};
